// CSS `scroll-behavior` has no effect on scrollTo({ behavior: 'smooth' }): the guard must be in JS.
export const scrollBehavior = () =>
  window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ? 'auto'
    : 'smooth';

const FOCUSABLE_TARGET =
  'a[href], area[href], button, details, iframe, input, select, textarea, [tabindex], [contenteditable]';

// Anchor handlers cancel the native jump, and with it the focus move the browser would have done.
export const focusScrollTarget = element => {
  if (!element.matches(FOCUSABLE_TARGET)) {
    element.setAttribute('tabindex', '-1');
  }

  element.focus({ preventScroll: true });
};
